export enum NOTIFICATIONS_LIST_FILTERS {
  ALL = 'all',
  UNREAD = 'unread',
}

export type NotificationsListFilters =
  | NOTIFICATIONS_LIST_FILTERS.ALL
  | NOTIFICATIONS_LIST_FILTERS.UNREAD;
